import React from "react";

export default function PartnershipProcessSection({ data, onStartConversation }) {
  if (!data?.cards?.length) {
    return null;
  }

  return (
    <section className={`partnership-process-section ${data.className || ""}`.trim()}>
      <div className="container">
        <div className="partnership-process-section-heading text-center">
          {data.eyebrow && <span className="main-title">{data.eyebrow}</span>}
          <h2 className="heading text-capitalize">{data.title}</h2>
          {Array.isArray(data.paragraphs) && data.paragraphs.length > 0 && (
            <div className="partnership-process-section-intro">
              {data.paragraphs.map((paragraph, index) => (
                <p key={`${paragraph}-${index}`}>{paragraph}</p>
              ))}
            </div>
          )}
        </div>

        {data.cardsTitle && (
          <h3 className="partnership-process-section-cards-title text-center">
            {data.cardsTitle}
          </h3>
        )}
        <div className="row partnership-process-section-cards">
          {data.cards.map((card, index) => (
            <div
              className={`${data.cards.length === 4 ? "col-lg-3" : "col-lg-4"} col-md-6`}
              key={card.title || card.value}
            >
              <article className="partnership-process-card">
                <span className="partnership-process-card-number">
                  {card.value || String(index + 1).padStart(2, "0")}
                </span>
                {card.title && <h3>{card.title}</h3>}
                <p>{card.description}</p>
                {card.source && (
                  <cite className="partnership-process-card-source">
                    {card.source}
                  </cite>
                )}
              </article>
            </div>
          ))}
        </div>

        {data.button && onStartConversation && (
          <div className="partnership-process-section-action text-center">
            <button type="button" className="default-btn" onClick={onStartConversation}>
              {data.button}
            </button>
          </div>
        )}
      </div>
    </section>
  );
}
